import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import Alert from 'components/Alert';
import { Button } from 'ui-kit';

const OwnerAlert = ({ logout }) => (
  <Row className="Store_row Store_top_warning" justify="center">
    <Col xs={24}>
      <Alert type="warning" closable>
        This is a preview of your store. To make a purchase or see full guest view please{' '}
        <Button onClick={logout}>log out</Button>.
      </Alert>
    </Col>
  </Row>
);

OwnerAlert.propTypes = {
  logout: PropTypes.func.isRequired,
};

export default OwnerAlert;
